import React, { createContext, useState, useEffect } from 'react';
import { auth, db } from '../FireBase'; // Import Firebase
import {

  onAuthStateChanged,
  signOut,
} from 'firebase/auth';
import { doc, setDoc, getDoc,where,collection,query,getDocs } from 'firebase/firestore';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {

  const [alert, setAlert] = useState('');


  // Clear alert messages
  const clearError = () => setAlert('');

  // Generate a custom user ID
  const generateCustomId = () => {
    const timestamp = Date.now().toString().slice(-6); // Last 6 digits of timestamp
    const randomStr = Math.random().toString(36).substring(2, 6).toUpperCase(); // Random string
    return `CUSND-${timestamp}-${randomStr}`;
  };

  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        try {
          const q = query(collection(db, 'users'), where('phone', '==', user.phoneNumber)); // Create a query
          const querySnapshot = await getDocs(q); // Execute the query

          if (!querySnapshot.empty) {
            const userDocSnap = querySnapshot.docs[0]; // Get the first document
            const userData = { ...user, ...userDocSnap.data() };
            setCurrentUser(userData);
          } else {
            const newUser = {
              uid: user.uid,
              phoneNumber: user.phoneNumber || '',
              createdAt: new Date(),
            };
            // const userDocRef = doc(db, 'users', user.uid);
            // await setDoc(userDocRef, newUser);
            setCurrentUser(newUser);
          }
        } catch (error) {
          console.error('Error fetching user data:', error);
        }
      } else {
        setCurrentUser(null);
      }
      setLoading(false);
    });

    return unsubscribe;
  }, []);

  

  // const checkUserAndSet = async (phoneNumber) => {
  //   try {
  //     const userDocRef = doc(db, 'users', phoneNumber);
  //     const userDoc = await getDoc(userDocRef);
  //     const cusmid = generateCustomId();
  //     if (userDoc.exists()) {
  //       setCurrentUser(userDoc.data());
  //       return userDoc.data();
        
  //     } else {
  //       const newUser = {
  //         cusmid,
  //         phone:phoneNumber,
  //         createdAt: new Date(),
  //       };
  //       await setDoc(userDocRef, newUser);
  //       setCurrentUser(newUser);
  //       return newUser; 
  //     }
  //   } catch (error) {
  //     console.error('Error checking user data:', error);
  //     throw error;
  //   }
  // };


const checkUserAndSet = async (phoneNumber, navigate) => {
  try {
    const userDocRef = doc(db, "users", phoneNumber);
    const userDoc = await getDoc(userDocRef);
    const cusmid = generateCustomId();

    if (userDoc.exists()) {
      setCurrentUser(userDoc.data());
      navigate("/"); // Redirect to HomePage if user exists
      return userDoc.data();
    } else {
      const newUser = {
        cusmid,
        phone: phoneNumber,
        createdAt: new Date(),
        profileComplete:false,
      };
       await setDoc(userDocRef, newUser);
      setCurrentUser(newUser);
      navigate("/account"); // Redirect to AccountInfo page if new user
      return newUser;
    }
  } catch (error) {
    console.error("Error checking user data:", error);
    throw error;
  }
};


 



  // Logout user
  const logout = async () => {
    try {
      await signOut(auth);
      setCurrentUser(null);
      setAlert('');
    } catch (error) {
      console.error('Logout Error:', error.message);
      setAlert('Failed to log out. Please try again.');
      setTimeout(clearError, 3000);
    }
  };



  return (
    <AuthContext.Provider value={{ currentUser, logout, alert, checkUserAndSet }}>
      {!loading && children}
    </AuthContext.Provider>
  );
};

